import { render, staticRenderFns } from "./my-select.vue?vue&type=template&id=22ce3ba9&scoped=true&"
import script from "./my-select.vue?vue&type=script&lang=js&"
export * from "./my-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce3ba9",
  null
  
)

export default component.exports